export default __webpack_public_path__ + "static/form-default-values-dont-6db2b496d554529403adfe680189fd69dc2b5435b96474cb4d2e89dcac6fc0bb.png";